export default function AJAX_Request() {
  return (
    <div>
      <h1>AJAX_Request</h1>
      <p>This is the AJAX_Request component.</p>
    </div>
  );
}